import { getUnseenReleases, type ChangelogRelease } from '@hit-app/convex/changelog';
import { useCallback, useState } from 'react';
import { posthogClient } from './posthog';

// Zuletzt gesehene Release-id (YYYY-MM-DD). Bleibt pro Browser erhalten, kein Server-Call.
const LAST_SEEN_RELEASE_STORAGE_KEY = 'hit-whats-new-last-seen';

function readLastSeenReleaseId(): string | null {
  try {
    return window.localStorage.getItem(LAST_SEEN_RELEASE_STORAGE_KEY);
  } catch {
    // localStorage kann im privaten Modus oder bei blockierten Cookies fehlen
    return null;
  }
}

function writeLastSeenReleaseId(releaseId: string) {
  try {
    window.localStorage.setItem(LAST_SEEN_RELEASE_STORAGE_KEY, releaseId);
  } catch {
    // Ohne Storage erscheint der Dialog beim nächsten Start erneut; das ist akzeptabel
  }
}

/** Liefert die beim Start noch nicht gesehenen Releases (neueste zuerst) und markiert sie beim Schliessen als gesehen. */
export function useWhatsNew() {
  const [releases, setReleases] = useState<ChangelogRelease[]>(() => getUnseenReleases('web', readLastSeenReleaseId()));

  const dismiss = useCallback(() => {
    const newest = releases[0];
    if (newest) {
      writeLastSeenReleaseId(newest.id);
      posthogClient.capture('whats_new_dismissed', {
        release_ids: releases.map((release) => release.id),
        platform: 'web',
      });
    }
    setReleases([]);
  }, [releases]);

  return { releases, dismiss };
}
